module.exports = __webpack_public_path__ + "img/with_matress.d9ddcd3a.jpg";